var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hlt-multiselect"},[_c('multiselect',_vm._g(_vm._b({ref:"multi",attrs:{"track-by":_vm.trackBy,"label":_vm.label},on:{"open":_vm.openHandler}},'multiselect',_vm.$attrs,false),_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }